export default "__VITE_ASSET__ypegcKN8__"